module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<p class="dim">\n  Would you like to add an icon to associate with your offer?\n</p>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./offers/templates/image-none.html
// module id = 296
// module chunks = 0